module.exports = __webpack_public_path__ + "static/media/oislb400_dc_scan_ico.d306e069.ico";